import Signature, { SignatureRef } from "@uiw/react-signature";
import { Button, Modal } from "antd";
import { FC, useEffect, useRef, useState } from "react";
import styles from "./SignatureModal.module.css";

interface Props {
  onSubmitSignature: (signature: string) => void;
  onClearSignature?: () => void;
  currentSignature?: string;
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
  currentTitle?: string;
}

/**========================================================================
 *                          external const here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const SignatureModal: FC<Props> = ({
  onSubmitSignature,
  onClearSignature,
  currentSignature,
  visible,
  setVisible,
  title = "Sign Below",
  currentTitle = "Using saved signature"
}) => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/
  const $svg = useRef<SignatureRef>(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const [isUsingCurrent, setIsUsingCurrent] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if ($svg.current) {
        const svgElement: any = $svg.current.svg;

        const observer = new MutationObserver(() => {
          isSignatureEmpty();
        });
        observer.observe(svgElement, { childList: true, subtree: true });
        return () => observer.disconnect();
      }
    }, 200);
  }, [visible, isUsingCurrent]);

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Const here
   *========================================================================**/

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/

  const submitSignature = (signature: string) => {
    closeModal();
    onSubmitSignature(signature);
  };

  const closeModal = () => {
    setIsUsingCurrent(false);
    clearSignature();
    setVisible(false);
  };

  const isSignatureEmpty = () => {
    const svg = $svg?.current?.svg;
    if (!svg) {
      setIsEmpty(true);
      return;
    }
    const hasPaths = svg.querySelectorAll("path")?.length > 0;
    setIsEmpty(!hasPaths);
  };

  const clearSignature = () => {
    $svg.current?.clear();
    setTimeout(() => {
      setIsEmpty(true);
    }, 100);
  };
  const SubmitBase64Img = () => {
    const svg = $svg?.current?.svg;
    if (svg) {
      const svgString = new XMLSerializer().serializeToString(svg);
      const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(svgBlob);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        canvas.width = 430;
        canvas.height = 160;
        ctx?.drawImage(img, 0, 0);
        const base64 = canvas.toDataURL("image/png");
        URL.revokeObjectURL(url);
        submitSignature(base64);
      };

      img.src = url;
    }
  };
  const btns1 = [
    <Button key="cancel" onClick={() => closeModal()}>
      Cancel
    </Button>,
    !!currentSignature && currentSignature !== 'data:image/png;base64,' && (
      <Button
        key="saved"
        type="primary"
        onClick={() => {
          clearSignature();
          setIsUsingCurrent(true);
        }}
      >
        use saved
      </Button>
    ),
    <Button key="clear" type="primary" danger onClick={() => clearSignature()}>
      Clear
    </Button>,
    <Button disabled={isEmpty} key="submit" type="primary" onClick={() => SubmitBase64Img()}>
      submit
    </Button>
  ];
  const btns2 = [
    <Button key="cancel" onClick={() => closeModal()}>
      Cancel
    </Button>,
    <Button key="back" onClick={() => setIsUsingCurrent(false)}>
      back
    </Button>,
    <Button disabled={!currentSignature} key="submit" type="primary" onClick={() => submitSignature(currentSignature || "")}>
      submit
    </Button>
  ];
  /*============================ END OF SECTION ============================*/

  return (
    <Modal
      title={isUsingCurrent ? currentTitle : title}
      onCancel={closeModal}
      centered={true}
      visible={visible}
      footer={isUsingCurrent ? btns2 : btns1}
    >
      {/* /========================================================================  HTML here
    ========================================================================*/}
      <div className={styles.signatureContainer}>
        {isUsingCurrent ? (
          <img width="100%" height="100%" src={currentSignature} alt="no signature" />
        ) : (
          <Signature width="100%" height="100%" ref={$svg} />
        )}
      </div>

      {/*============================ END OF SECTION ============================*/}
    </Modal>
  );
};
